import {
  booleanOptions,
  getCategories,
  Input,
  MultiSearchForm,
  useEffect,
  useState,
} from "@";
import type { Category, SearchValues } from "../types";

interface MultiSearchProps {
  onSubmit: () => void;
  search: {
    show: boolean;
    values: SearchValues;
  };
  updateSearch: (params: { show?: boolean; values?: SearchValues }) => void;
  onReset: () => void;
}

const MultiSearch = ({
  onSubmit,
  search,
  updateSearch,
  onReset,
}: MultiSearchProps) => {
  const [categories, setCategories] = useState<Category[]>([]);

  useEffect(() => {
    getCategories().then(({ data }) => setCategories(data || []));
  }, []);

  const handleInputChange = (field: keyof SearchValues, value: string) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <>
      <MultiSearchForm
        show={search.show}
        onSubmit={onSubmit}
        className="multi-search-form xl:grid-cols-4"
        reset={onReset}
      >
        {/* Input field for searching projects */}
        <Input
          star
          label="كلمة البحث"
          value={search.values.title}
          change={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange("title", e.target.value)
          }
        />

        {/* Input field for selecting categories */}
        <Input
          star
          type="select"
          label="التصنيف"
          list={categories}
          value={search.values.classificationIds}
          change={(e: React.ChangeEvent<HTMLSelectElement>) =>
            handleInputChange("classificationIds", e.target.value)
          }
        />

        {/* Input fields for date range */}
        <Input
          star
          showTimeSelect
          type="date-range"
          style="lg:col-span-2"
          labelA="من تاريخ"
          labelB="الي تاريخ"
          valueB={search.values.toDate}
          valueA={search.values.fromDate}
          changeA={(e: string) => handleInputChange("fromDate", e)}
          changeB={(e: string) => handleInputChange("toDate", e)}
        />

        {/* Input fields for amount range */}
        <Input
          star
          type="number-range"
          labelA="المبلغ من"
          labelB="المبلغ الي"
          valueB={search.values.toAmount}
          valueA={search.values.fromAmount}
          changeA={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange("fromAmount", e.target.value)
          }
          changeB={(e: React.ChangeEvent<HTMLInputElement>) =>
            handleInputChange("toAmount", e.target.value)
          }
        />

        <div className="grid grid-cols-2 gap-5 lg:col-span-3 lg:grid-cols-4 xl:col-span-3">
          {/* Input fields for boolean */}
          <Input
            star
            label="نشط"
            type="select"
            list={booleanOptions}
            value={search.values.isActive}
            change={(e: React.ChangeEvent<HTMLSelectElement>) =>
              handleInputChange("isActive", e.target.value)
            }
          />

          <Input
            star
            label="الارشيف"
            type="select"
            list={booleanOptions}
            value={search.values.isArchived}
            change={(e: React.ChangeEvent<HTMLSelectElement>) =>
              handleInputChange("isArchived", e.target.value)
            }
          />

          <Input
            star
            label="العرض في المنصة"
            type="select"
            list={booleanOptions}
            value={search.values.showInHomePage}
            change={(e: React.ChangeEvent<HTMLSelectElement>) =>
              handleInputChange("showInHomePage", e.target.value)
            }
          />

          <Input
            star
            label="مكتمل"
            type="select"
            list={booleanOptions}
            value={search.values.isCompleted}
            change={(e: React.ChangeEvent<HTMLSelectElement>) =>
              handleInputChange("isCompleted", e.target.value)
            }
          />
        </div>
      </MultiSearchForm>
    </>
  );
};

export default MultiSearch;
